import React, { useState } from 'react';
import { Modal } from 'antd';
import './quick-start-modal.scss';
import { ApplyingPolicyModalContent } from '../policy-modal/applying-policy-modal-content';
import { QuickStartModalContent } from './quick-start-modal-content';

interface QuickStartModalProps {
    visible: boolean;
    setIsVisible: (visible: boolean) => void;
}

export const QuickStartModal: React.FC<QuickStartModalProps> = ({ visible, setIsVisible }) => {
    const [isApply, setIsApply] = useState(false);

    const closeModal = () => {
        setIsVisible(false);
    };

    return <Modal open={visible}
                  className={'policy-modal'}
                  width={680}
                  closable={false}
                  footer={null}
                  centered>
        {!isApply ?
            <QuickStartModalContent closeModal={closeModal} setIsApply={setIsApply}/> :
            <ApplyingPolicyModalContent onClickGotIt={closeModal}/>}

    </Modal>;
};